import React, { useState } from 'react';
import Filters, { filtersInitialState } from './Filters/Filters';
import FiltersProvider from '../../Common/Filters/contexts/FiltersContext';
import { Modal } from '@mui/material';
import { Buttons } from '../../Common/Filters/Buttons';
import CityFilter from '../../Common/Filters/CityFilter';

const ChartsContainer = ({
    title,
    className,
    children,
    showRegisterTypeResults = false,
    showRegisterTypeRegisters = false,
    showServiceTypesStratified = false,
    showServiceTypesProfessionals = false,
    showLocation = true,
    showHouseholdStatus = false,
    showImmunobiologicals = false,
    showImmunobiologicalsDoses = false,
    showProcedureGroup = false,
    showProcedureSubgroup = false,
    showProcedures = false,
    showCbo = false
}) => {
    const [open, setOpen] = useState(false);
    const [isCityFilterOpen, setIsCityFilterOpen] = useState(false);

    return (
        <div className={`${className}`}>
            <FiltersProvider initialState={filtersInitialState}>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '16px'
                    }}
                >
                    <h2 className="title-dashboards">{title}</h2>
                    <Buttons
                        onClickFilters={() => setOpen(true)}
                        onClickCityFilter={() => setIsCityFilterOpen(true)}
                    />
                    <Modal open={open} onClose={() => setOpen(false)}>
                        <div
                            style={{
                                position: 'absolute',
                                top: '10%',
                                left: '50%',
                                transform: 'translate(-50%, 0)',
                                backgroundColor: '#fff',
                                padding: '24px',
                                borderRadius: '8px',
                                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                                maxWidth: '90vw',
                                width: '80%'
                            }}
                        >
                            <Filters
                                showRegisterTypeResults={
                                    showRegisterTypeResults
                                }
                                showRegisterTypeRegisters={
                                    showRegisterTypeRegisters
                                }
                                showLocation={showLocation}
                                showServiceTypesStratified={
                                    showServiceTypesStratified
                                }
                                showServiceTypesProfessionals={
                                    showServiceTypesProfessionals
                                }
                                showHouseholdStatus={showHouseholdStatus}
                                showImmunobiologicals={showImmunobiologicals}
                                showImmunobiologicalsDoses={
                                    showImmunobiologicalsDoses
                                }
                                showProcedureGroup={showProcedureGroup}
                                showProcedureSubgroup={showProcedureSubgroup}
                                showProcedures={showProcedures}
                                showCbo={showCbo}
                            />
                        </div>
                    </Modal>
                    <Modal
                        open={isCityFilterOpen}
                        onClose={() => setIsCityFilterOpen(false)}
                    >
                        <div
                            style={{
                                position: 'absolute',
                                top: '10%',
                                left: '50%',
                                transform: 'translate(-50%, 0)',
                                backgroundColor: '#fff',
                                padding: '24px',
                                borderRadius: '8px',
                                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                                maxWidth: '90vw',
                                width: '80%'
                            }}
                        >
                            <CityFilter />
                        </div>
                    </Modal>
                </div>

                <div className="charts-container-dashboards">{children}</div>
            </FiltersProvider>
        </div>
    );
};

export default ChartsContainer;
